export default __webpack_public_path__ + "static/app-store-badge-f631ea7a76dd4da4389989acbf775599.svg";